import PropTypes from 'prop-types';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import sanitize from 'rehype-sanitize';
import rehypeRaw from 'rehype-raw';

import Link from 'core/components/Link';
import Heading from 'core/components/Heading';


export default function MarkdownWrapper(props) {
  const {
    interitemSpacing,
    components,
    inline,
    ...otherProps
  } = props;

  return (
    <Markdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw, sanitize]}
      components={{
        a({ children, href }) {
          return <Link to={href}>{children}</Link>;
        },
        h1: Heading,
        h2: Heading,
        h3: Heading,
        h4: Heading,
        h5: Heading,
        h6: Heading,

        p({ children }) {
          if (inline) return <>{children}</>;

          return (
            <p>
              <style jsx>{`
                p
                  margin ${interitemSpacing}px 0
                  &:first-child
                    margin-top 0
                  &:last-child
                    margin-bottom 0
              `}</style>
              {children}
            </p>
          );
        },
        ...components,
      }}
      {...otherProps}
    />
  );
}

MarkdownWrapper.defaultProps = {
  interitemSpacing: 0,
};

MarkdownWrapper.propTypes = {
  /**
   * Свойство, отвечающее за вертикальные отступы между параграфами
   */
  interitemSpacing: PropTypes.number,
  /**
   * markdown
   */
  children: PropTypes.string,
  /**
   * Коллекция кастомных рендереров
   */
  components: PropTypes.object,
  /**
   * Отключает параграфы в маркдауне. Таким образом строка рендерится инлайном
   * и не создаётся дополнительная обертка-параграф в тексте
   */
  inline: PropTypes.bool,
};
